import {BatchSpanProcessor, WebTracerProvider,} from '@opentelemetry/sdk-trace-web';
import {OTLPTraceExporter} from '@opentelemetry/exporter-trace-otlp-http';
import {Resource} from '@opentelemetry/resources';
import {SEMRESATTRS_SERVICE_NAME, SEMRESATTRS_SERVICE_VERSION} from "@opentelemetry/semantic-conventions";


const provider = new WebTracerProvider({
    resource: Resource.default().merge(new Resource({
        [SEMRESATTRS_SERVICE_NAME]: "msgr-ls",
        [SEMRESATTRS_SERVICE_VERSION]: "0.0.1",
    })),
});

let otlp_exporter_config = {
    url: process.env.VUE_APP_BASE_API_MESSENGER + "/live-support/traces",
    concurrencyLimit: 10, // an optional limit on pending requests
};

import {storage} from '../utils/map'

const JWT_KEY = 'fptai_messenger_user_jwt';
if (storage.has(JWT_KEY)) {
    let userInfo = storage.getItem(JWT_KEY);
    otlp_exporter_config.headers = {Authorization: `Bearer ${userInfo.user_token}`}
}

const exporter = new OTLPTraceExporter(otlp_exporter_config);
provider.addSpanProcessor(new BatchSpanProcessor(exporter, {
    // The maximum queue size. After the size is reached spans are dropped.
    maxQueueSize: 100,
    // The maximum batch size of every export. It must be smaller or equal to maxQueueSize.
    maxExportBatchSize: 10,
    // The interval between two consecutive exports
    scheduledDelayMillis: 500,
    // How long the export can run before it is cancelled
    exportTimeoutMillis: 30000,
}));

provider.register();
